import PrivacyPolicyChange from './PrivacyPolicyChange';

const GlobalBannerContainer = () => {
  return <PrivacyPolicyChange />;
};

export default GlobalBannerContainer;
